import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SwitchComponent } from './switch.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    exports: [SwitchComponent],
    declarations: [SwitchComponent],
    providers: [],
})
export class SwitchModule { }
